if (!customElements.get('care-guide')) {
  customElements.define(
    'care-guide',
    class CareGuide extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('click', (e) => {
          const clickedElement = e.target.closest('[data-care-btn]');
          if (!clickedElement) return;

          const targetCareInstructions = clickedElement.dataset.careBtn;
          const targetCareInstructionsEl = document.querySelector(`[data-care-instructions="${targetCareInstructions}"]`);
          if (!targetCareInstructionsEl) return;

          document.querySelector('[data-care-btn].active')?.classList.remove('active');
          document.querySelector('[data-care-btn]')?.setAttribute('aria-current', 'false')
          clickedElement.setAttribute('aria-current', 'true')

          document.querySelector('[data-care-instructions].active')?.classList.remove('active');
          targetCareInstructionsEl.classList.add('active');
          clickedElement.classList.add('active');

          const headerHeight = document.querySelector('header').offsetHeight;
          const targetCareInstructionsElOffsetTop = targetCareInstructionsEl.offsetTop - headerHeight;
          
          window.scrollTo({ top: targetCareInstructionsElOffsetTop, left: 0, behavior: 'smooth' });
          targetCareInstructionsEl.focus();
        });
      } 
    }
  );
}